module.exports = __webpack_public_path__ + "img/m5luoding.prt.27f025cc.jpg";